import { TweenEngineGreenSock } from './TweenEngineGreenSock3';
/**
 * Constructor for a local tween engine.
 */
export class TweenEngine {
    constructor(gsap, plugins) {
        this.engine = new TweenEngineGreenSock(gsap, plugins);
    }
}
//# sourceMappingURL=TweenEngine.js.map